<template>
  <div :class="ispreview ? 'preview' : ''">
    <FormList
      :list="extendField"
      :data="formData"
      :onChange="onChange"
    />
  </div>
</template>

<script>
import FormList from '@components/FormList'
export default {
  props: {
    formData: {
      type: Object,
      default: () => {}
    },
    onChange: {
      type: Function,
      default: () => {}
    },
    ispreview: {
      type: Boolean,
      default: false
    },
    applyModule: {
      type: String,
      default: '3'
    },
    secretKey: {
      type: String,
      default: ''
    },
    notAuth: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      typeMapping: {
        0: 'text',
        1: 'number',
        2: 'number',
        3: 'dateForm'
      }
    }
  },
  mounted () {
    this.getExtendField()
  },
  computed: {
    extendField () {
      let formList = []
      this.$store.state.user.extendField.forEach(i => {
        formList.push({
          type: this.typeMapping[i.extType],
          field: i.interMapping,
          label: i.extName,
          placeholder: this.ispreview ? '' : `请${i.extType === 3 ? '选择' : '填写'}${i.requiredFlag ? '(必填)' : '(非必填)'}`,
          readonly: this.ispreview
        })
      })
      return formList
    }
  },
  methods: {
    async getExtendField () {
      if (this.notAuth) {
        await this.$store.dispatch({
          type: 'user/getNotAuthExtendField',
          applyModule: this.applyModule,
          secretKey: this.secretKey
        })
      } else {
        await this.$store.dispatch({
          type: 'user/getExtendField',
          applyModule: this.applyModule
        })
      }
    }
  },
  components: {
    FormList
  }
}
</script>

<style lang="less" scoped>
.preview /deep/.input-field-wrapper .van-cell{
  padding-left: 0 !important;
}
.preview >div /deep/.input-field-wrapper .van-cell{
  padding-left: 0 !important;
  .van-cell__title{
    font-size: 14px;
    color: #9EA9B9;
  }
}
</style>
